import React from 'react';
import {ArticleView} from 'epic-minimalist-blog/app/scripts';

export default function ArticleWrapper(props) {
    return (
        <div className="blog-wrapper">
            <ArticleView {...props} rootPageSlug="news" />
        </div>
    );
}
